import AppMonitor from './AppMonitor';

/**
 * @returns {void}
 */
export default function initErrorMonitor() {
	AppMonitor.init();
}
